import { createContext, useContext } from 'react'

export type ToastTone = 'neutral' | 'accent' | 'danger'

export type ToastOptions = {
  message: string
  tone?: ToastTone
  action?: { label: string; onClick: () => void }
  /** Сколько показывать, мс; null — пока не закроют (по умолчанию 4000). */
  duration?: number | null
  /** Тот же id заменяет прежний тост, а не добавляет второй. */
  id?: string
}

export type ToastApi = {
  show: (options: ToastOptions) => string
  dismiss: (id: string) => void
}

export const ToastContext = createContext<ToastApi | null>(null)

/** Всплывающие сообщения: `const toast = useToast(); toast.show({ message: 'Сохранено' })`. */
export function useToast(): ToastApi {
  const api = useContext(ToastContext)
  if (!api) throw new Error('useToast вне ToastProvider')
  return api
}
